import { useMutation, useQueryClient } from "@tanstack/react-query";

import { reorderOption } from "../../services/option";

const useReorderOption = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: reorderOption,
        onSuccess: (status) => {
            if (status === 200) {
                queryClient.invalidateQueries({ queryKey: ["question-options"] });
            }
        }, onError: (error) => { }
    });
}

export default useReorderOption;